<template>
  <!-- 售后详情 -->
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col span="24">
            <h4>申请信息</h4>
          </el-col>
          <el-col span="12">
            <el-form-item label="售后账单" prop="code">
              <div>{{ form.code }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="服务单号" prop="orderCode">
              <el-button type="text" @click="showOrderDetail(row.outOrderId)" style="padding: 0;"
                ><div>{{ form.orderCode }}</div></el-button
              >
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="申请原因" prop="applyReason">
              <el-input
                :disabled="true"
                type="textarea"
                maxlength="500"
                v-model="form.applyReason"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="申请附件" prop="applyAttachList">
              <VUpload disabled :fileList="form.applyAttachList" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="申请时间" prop="createTime">
              <div>{{ form.createTime }}</div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="申请人" prop="applyUserName">
              <div>{{ form.applyUserName }}</div>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <h4>处理信息</h4>
          </el-col>
          <div v-if="form.afterSalesStatus != 0">
            <el-col span="8">
              <el-form-item label="处理状态" prop="afterSalesStatus">
                <el-select v-model="form.afterSalesStatus" :disabled="true">
                  <el-option
                    v-for="item in afterSalesStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="是否退款" prop="refundFlag">
                <el-radio-group v-model="form.refundFlag" disabled>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="退款金额" prop="refundAmount" class="form-flex">
                <el-input
                  type="text"
                  disabled
                  v-model="form.refundAmount"
                ></el-input>
                <span>元</span>
              </el-form-item>
            </el-col>
            <el-col span="24">
              <el-form-item label="处理记录" prop="handleRecord">
                <el-input
                  disabled
                  type="textarea"
                  maxlength="200"
                  v-model="form.handleRecord"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col span="24">
              <el-form-item label="处理附件" prop="handleAttachList">
                <VUpload disabled :fileList="form.handleAttachList" />
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="处理时间" prop="handleTime">
                <div>{{ form.handleTime }}</div>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="处理人" prop="handleUserName">
                <div>{{ form.handleUserName }}</div>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </el-form>
      <orderDetail ref="orderDetailRef" v-if="isNeedOrderDetailShow" :orderId="orderId">
      </orderDetail>
    </div>
  </div>
</template>
  <script>
import VUpload from '@/views/components/v-upload.vue';
import afterSaleDetails from './afterSaleDetails.vue';
import orderDetail from './orderDetail.vue';
import { getDetail, getDictData } from '@/api/v4ward/out/order/after/sales/outorderaftersales.js';
export default {
  components: {
    VUpload,
    afterSaleDetails,
    orderDetail,
  },
  props: {
    row: {
      default: {},
    },
  },
  data() {
    return {
      orderId: '', // 工单id
      isNeedOrderDetailShow: false,
      form: {
        code: '',
        orderCode: '',
        applyReason: '',
        applyAttachList: [],
        createTime: '',
        applyUserName: '',
        handleRecord: '',
        handleAttachList: [],
        handleTime: '',
        handleUser: '',
        afterSalesStatus: '',
        refundFlag: null,
        refundAmount: null,
      },
      afterSalesStatusList: [],
      formRules: {},
    };
  },
  created() {
    getDictData({ code: 'out_order_after_sales_status' }).then((res) => {
      this.afterSalesStatusList = res.data;
    });
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    /* 显示工单详情 */
    showOrderDetail(orderId) {
      this.orderId = orderId;
      if (this.isNeedOrderDetailShow) {
        this.$refs.orderDetailRef.show();
      } else {
        this.isNeedOrderDetailShow = true;
        this.$nextTick(() => {
          this.$refs.orderDetailRef.show();
        });
      }
    },
    //获取列表详情
    async initData() {
      getDetail({ id: this.row.id }).then((res) => {
        this.form = res.data;
        //字典类型转换
        this.form.afterSalesStatus += '';
      });
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
::v-deep .form-flex {
  .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      margin-left: 10px;
    }
  }
}
</style>
  